<template>
  <div class="Wrap" id="calendar-modal">
    <fieldset>
      <div class="flex">
        <div class="Calendar">
          <div class="Cr-Head">
            <div class="Cr-Head_ltMonth" @click="ltMonth">
              <svg
                width="9"
                height="14"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.2259 12.2194L1.79297 6.78644L7.2259 1.35352"
                  stroke="#474D52"
                  stroke-width="1.81098"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="Cr-Head_currMonth">
              {{ months[currMonth].slice(0, 3) }} {{ currYear }}
            </div>
            <div class="Cr-Head_gtMonth" @click="gtMonth">
              <svg
                width="9"
                height="14"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.77539 12.2194L7.20832 6.78644L1.77539 1.35352"
                  stroke="#474D52"
                  stroke-width="1.81098"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div class="Cr-Week">
            <div class="Cr-Week_day" v-for="(day, i) in days" :key="i">
              {{ day }}
            </div>
          </div>
          <div class="Cr-Days">
            <div
              class="Cr-Days_blank"
              v-for="(blank, j) in daysOfPrevMonth"
              :key="j"
            >
              {{ blank }}
            </div>
            <div
              class="Cr-Days_day"
              v-for="(i, k) in daysInMonth"
              :key="k"
              :class="{
                currDay: i == currDay,
                clickedDay: i == clickedDay
              }"
              @click="setDate(i)"
            >
              {{ i }}
            </div>
            <div
              class="Cr-Days_blank"
              v-for="(_, i) in qtyDaysNextMonth"
              :key="i"
            >
              {{ i + 1 }}
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
const NOW = new Date();
export default {
  data() {
    return {
      name: "Hafiz Javaid",
      inst_date: NOW,
      days: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      // period: "AM",
      clickedDay: null,
      output: {
        str: "", //19 Апр 2018
        format: "" //2018-04-19
      },
      hours: "12",
      mins: "00"
      // period: 'AM'
    };
  },
  methods: {
    addDate() {
      this.$emit("updateDate", {
        date: this.output,
        time: this.hours + ":" + this.mins
      });
    },
    ltMonth() {
      this.clickedDay = null;
      // this.clickedDay && this.reset()
      this.inst_date = new Date(this.currYear, this.currMonth - 1);
    },
    gtMonth() {
      this.clickedDay = null;
      // this.clickedDay && this.reset()
      this.inst_date = new Date(this.currYear, this.currMonth + 1);
    },
    reset() {
      this.clickedDay = null;
      // this.output.str = ''
      this.$emit("setdate", null);
    },
    setDate(day) {
      this.clickedDay = day;

      const fixDay = day < 10 ? "0" + day : day;
      const fixMonth =
        this.currMonth + 1 < 10
          ? "0" + (this.currMonth + 1)
          : this.currMonth + 1;

      this.output.str = `${day} ${this.months[this.currMonth]} ${
        this.currYear
      }`;
      this.output.format = `${this.currYear}-${fixMonth}-${fixDay}`;

      this.$emit("setdate", this.output);
    }
  },
  computed: {
    currYear() {
      return this.inst_date.getFullYear();
    },
    currMonth() {
      return this.inst_date.getMonth();
    },
    currWD() {
      return this.inst_date.getDay();
    },
    currDay() {
      // !TODO wtf
      if (
        this.inst_date.getMonth() === NOW.getMonth() &&
        this.inst_date.getFullYear() === NOW.getFullYear()
      ) {
        return NOW.getDate();
      }
    },
    daysInMonth() {
      return new Date(this.currYear, this.currMonth + 1, 0).getDate();
    },
    _lastDateOfPrevMonth() {
      return new Date(this.currYear, this.currMonth, 0).getDate();
    },
    _qtyDaysPrevMonth() {
      return new Date(this.currYear, this.currMonth, 0).getDay();
    },
    daysOfPrevMonth() {
      return (
        this._qtyDaysPrevMonth &&
        Array.from(
          { length: this._qtyDaysPrevMonth },
          (v, k) => this._lastDateOfPrevMonth - this._qtyDaysPrevMonth + (k + 1)
        )
        /*
        Array.from(
          { length: this._qtyDaysPrevMonth },
          (v, k) => this._lastDateOfPrevMonth - k
        ).reverse()
        */
      );
    },
    qtyDaysNextMonth() {
      return 42 - (this.daysInMonth + this._qtyDaysPrevMonth);
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.Calendar {
  border-radius: 9px;
  margin: auto;
  // box-shadow: 0 0 20px rgba(51, 51, 51, 0.5);
  width: 330px;
  text-align: center;
  user-select: none;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 1px #000;
}
.Wrap {
  position: absolute;
  top: 15%;

  right: 5%;
  z-index: 2;
}
.Cr-Head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.Cr-Head,
.Cr-Week,
.Cr-Days {
  display: flex;
}
.Cr-Head,
.Cr-Week {
  font-weight: bold;
}
.Cr-Week {
  line-height: 2em;
}
.Cr-Week_day {
  width: 40px;
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 14px;

  text-transform: uppercase;

  /* Secondary */

  color: #8d99a0;
}
.Cr-Head {
  background: #fff;
  color: #474d52;
  /* justify-content: space-between; */
  line-height: 40px;
}
.Cr-Head_currMonth {
  /* flex: 1; */
}
.Cr-Head_ltMonth,
.Cr-Head_gtMonth {
  cursor: pointer;
  width: 40px;
}
.Cr-Head_ltMonth:hover,
.Cr-Head_gtMonth:hover {
  /* background: var(--theme-color); */
}
.Cr-Days {
  flex-wrap: wrap;
  line-height: 40px;
}
.Cr-Days_blank,
.Cr-Days_day {
  width: 40px;
}
.Cr-Days_blank {
  color: #dee2e6;
}
.Cr-Days_day {
  cursor: pointer;
  border-radius: 50%;
  margin: 7px 0;
}
.Cr-Days_day:hover:not(.currDay):not(.clickedDay) {
  background: #dee2e6;
}
.Cr-Days .currDay {
  background: #ccc;
  position: relative;
}
.Cr-Days .clickedDay {
  color: #fff;
  font-weight: bold;
  background: var(--theme-color);
}
.time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  input {
    width: 102px;
    text-align: center;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 24px;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
